<div class="main-nav-wrapper">
  <a href="javascript:;" (click)="toggleMobileMenuActivity()" class="show-main-nav"><span class="menu-ico"></span><span class="name">Меню</span></a>
  <ul class="main-nav layout-fluid-constrained layout-align-center" [class.active]="isMobileMenuActive">
    @for (item of items; track item) {
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a routerLink="{{item.link}}">{{ item.title }}</a>
      </li>
    }
  </ul>
</div>
